// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-7af01d8b] {\n  font-size: 1rem;\n  color: #fff;\n}\n@media (min-width: 768px) {\n  .title[data-v-7af01d8b] {\n    font-size: 1.75rem;\n  }\n}\n.title--tnc[data-v-7af01d8b] {\n  font-size: 0.88rem;\n  color: #f8c51b;\n}\n\n.body[data-v-7af01d8b] {\n  color: #d3d3d3;\n}\n.body--tnc[data-v-7af01d8b] {\n  color: #d3d3d3;\n}", ""]);
// Exports
module.exports = exports;
